class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endDate = this.dataset.endDate;
    this.sectionWrapper = this.closest('.countdown-block-wrapper');
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');
  }

  connectedCallback() {
    if (!this.endDate) return;
    
    // if the date is in YYYY-MM-DD format.
    const normalizedDate = this.endDate.replace(/-/g, '/');
    this.targetDate = new Date(normalizedDate).getTime();
    
    // If invalid, fallback to standard parsing
    if (isNaN(this.targetDate)) {
      this.targetDate = new Date(this.endDate).getTime();
    }
    
    if (isNaN(this.targetDate)) {
      console.error('Invalid date format for countdown: ', this.endDate);
      return;
    }
    
    this.updateTimer();
    this.interval = setInterval(this.updateTimer.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.targetDate - now;

    if (distance < 0) {
      clearInterval(this.interval);
      if (this.sectionWrapper) {
        this.sectionWrapper.classList.add('hidden');
      } else {
        this.classList.add('hidden');
      }
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = days;
    if (this.hoursEl) this.hoursEl.textContent = hours.toString().padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = minutes.toString().padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = seconds.toString().padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
